<template>
  <footer>
    <div class="container">
      <div class="footer-content">
        <router-link to="/"
          ><button class="footer__btn">
            <i class="footer__icon">
              <svg
                width="36"
                height="37"
                viewBox="0 0 36 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.66668 20.0392C4.66668 18.9195 4.07736 17.9374 3.19197 17.3863L18 2.57822L32.808 17.3863C31.9227 17.9374 31.3333 18.9195 31.3333 20.0392V34.1665H28.5417C25.9413 34.1665 23.8333 32.0585 23.8333 29.4581V26.5831C23.8333 23.3615 21.2217 20.7498 18 20.7498C14.7783 20.7498 12.1667 23.3615 12.1667 26.5831V29.4581C12.1667 32.0585 10.0587 34.1665 7.45834 34.1665H4.66668V20.0392Z"
                  stroke="#D8DEF3"
                  stroke-width="4"
                />
              </svg>
            </i>
          </button>
        </router-link>

        <router-link to="tasks">
          <button class="footer__btn">
            <i class="footer__icon">
              <svg
                width="34"
                height="40"
                viewBox="0 0 36 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M31.4167 39.1667H4.58333C2.46624 39.1667 0.75 37.4504 0.75 35.3333V8.50001C0.75 6.38292 2.46624 4.66668 4.58333 4.66668H8.41667V2.75001C8.41667 1.69146 9.27479 0.833344 10.3333 0.833344C11.3919 0.833344 12.25 1.69146 12.25 2.75001V4.66668H23.75V2.75001C23.75 1.69146 24.6081 0.833344 25.6667 0.833344C26.7252 0.833344 27.5833 1.69146 27.5833 2.75001V4.66668H31.4167C33.5338 4.66668 35.25 6.38292 35.25 8.50001V35.3333C35.25 37.4504 33.5338 39.1667 31.4167 39.1667ZM4.58333 16.1667V34.3333C4.58333 34.8856 5.03105 35.3333 5.58333 35.3333H30.4167C30.969 35.3333 31.4167 34.8856 31.4167 34.3333V16.1667H4.58333ZM5.58333 8.50001C5.03105 8.50001 4.58333 8.94773 4.58333 9.50001V12.3333H31.4167V9.50001C31.4167 8.94772 30.969 8.50001 30.4167 8.50001H5.58333ZM27.5833 29.5833C27.5833 30.6419 26.7252 31.5 25.6667 31.5C24.6081 31.5 23.75 30.6419 23.75 29.5833C23.75 28.5248 24.6081 27.6667 25.6667 27.6667C26.7252 27.6667 27.5833 28.5248 27.5833 29.5833ZM19.9167 29.5833C19.9167 30.6419 19.0585 31.5 18 31.5C16.9415 31.5 16.0833 30.6419 16.0833 29.5833C16.0833 28.5248 16.9415 27.6667 18 27.6667C19.0585 27.6667 19.9167 28.5248 19.9167 29.5833ZM12.25 29.5833C12.25 30.6419 11.3919 31.5 10.3333 31.5C9.27479 31.5 8.41667 30.6419 8.41667 29.5833C8.41667 28.5248 9.27479 27.6667 10.3333 27.6667C11.3919 27.6667 12.25 28.5248 12.25 29.5833ZM27.5833 21.9167C27.5833 22.9752 26.7252 23.8333 25.6667 23.8333C24.6081 23.8333 23.75 22.9752 23.75 21.9167C23.75 20.8581 24.6081 20 25.6667 20C26.7252 20 27.5833 20.8581 27.5833 21.9167ZM19.9167 21.9167C19.9167 22.9752 19.0585 23.8333 18 23.8333C16.9415 23.8333 16.0833 22.9752 16.0833 21.9167C16.0833 20.8581 16.9415 20 18 20C19.0585 20 19.9167 20.8581 19.9167 21.9167ZM12.25 21.9167C12.25 22.9752 11.3919 23.8333 10.3333 23.8333C9.27479 23.8333 8.41667 22.9752 8.41667 21.9167C8.41667 20.8581 9.27479 20 10.3333 20C11.3919 20 12.25 20.8581 12.25 21.9167Z"
                  fill="#D8DEF3"
                />
              </svg>
            </i>
          </button>
        </router-link>

        <router-link to="/">
          <button class="footer__btn">
            <i class="footer__icon">
              <svg
                width="34"
                height="42"
                viewBox="0 0 34 42"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17 41.8333C14.6988 41.8333 12.8333 39.9678 12.8333 37.6666H21.1666C21.1666 39.9678 19.3012 41.8333 17 41.8333ZM33.6666 35.5833H0.333313V31.4166L4.49998 29.3333V17.875C4.49998 10.6625 7.4604 5.98538 12.8333 4.70829V4.33329C12.8333 2.03211 14.6988 0.166626 17 0.166626C19.3012 0.166626 21.1666 2.03211 21.1666 4.33329V4.70829C26.5396 5.98329 29.5 10.6583 29.5 17.875V29.3333L33.6666 31.4166V35.5833ZM17 7.97913C14.4576 7.81496 12.0058 8.95262 10.4896 11C9.19278 13.0511 8.55652 15.4508 8.66665 17.875V30.4166C8.66665 30.9689 9.11436 31.4166 9.66665 31.4166H24.3333C24.8856 31.4166 25.3333 30.9689 25.3333 30.4166V17.875C25.4433 15.4508 24.8071 13.0512 23.5104 11C21.9942 8.95262 19.5423 7.81496 17 7.97913Z"
                  fill="#D8DEF3"
                />
              </svg>
            </i>
          </button>
        </router-link>

        <router-link to="/">
          <button class="footer__btn">
            <i class="footer__icon"
              ><svg
                width="34"
                height="55"
                viewBox="0 0 55 55"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="29.4716"
                  y="34.2344"
                  width="5.67857"
                  height="16.0893"
                  rx="2.83929"
                  transform="rotate(-45 29.4716 34.2344)"
                  fill="#D8DEF3"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M35.1601 35.239C41.6282 28.771 41.6282 18.2842 35.1601 11.8161C28.6921 5.34804 18.2053 5.34804 11.7372 11.8161C5.26915 18.2842 5.26915 28.771 11.7372 35.239C18.2053 41.7071 28.6921 41.7071 35.1601 35.239ZM31.8139 31.8931C36.434 27.273 36.434 19.7825 31.8139 15.1624C27.1939 10.5424 19.7033 10.5424 15.0833 15.1624C10.4632 19.7825 10.4632 27.273 15.0833 31.8931C19.7033 36.5131 27.1939 36.5131 31.8139 31.8931Z"
                  fill="#D8DEF3"
                />
              </svg>
            </i>
          </button>
        </router-link>
      </div>
    </div>
    <router-view />
  </footer>
</template>

<script>
export default {};
</script>

<style>
footer {
  margin-top: 32px;
  bottom: 0;
  position: fixed;
  background-color: #fff;
  width: 100%;
}

.footer__icon {
  max-width: 30px;
}

.footer__btn {
  background-color: transparent;
  border: none;
}

.footer-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
